import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./Auth";
import { requiresPhoneUpdate } from "./phoneRequirement";
import WordQuestLoadingScreen from "../features/wordQuest/WordQuestLoadingScreen";

const ProtectedRoute = ({ children, allowIncompleteContact = false }) => {
  const { isAuthenticated, isUserHydrated, user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(false);
    };

    checkAuth();
  }, [location.pathname]);

  if (isLoading || !isUserHydrated) {
    return location.pathname.startsWith("/word-quest")
      ? <WordQuestLoadingScreen />
      : <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!allowIncompleteContact && requiresPhoneUpdate(user)) {
    return (
      <Navigate
        to="/complete-profile"
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
